module.exports = __webpack_public_path__ + "img/user.91e4ec22.svg";